import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { PaymentDatePicker } from 'components/PaymentDatePicker/PaymentDatePicker';
import { useFetchOpenGlCalendars } from 'hooks';
import { getUserRoleIsApOfficeManager } from 'pages/LandingPage/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  StyledHeaderContainer,
  StyledSelectedChecksSpan
} from '../dialogs/PrintChecksDialog/styled';
import {
  PrintChecksHeaderButton,
  CancelPaymentHeaderButton
} from '../headerButtons';
import { labels } from './messages';
import { PrintChecksCIBDropdown } from './PrintChecksCIBDropdown';
import { getSelectedVendors, setPrintBtnDisabledOnRowFiltering } from './slice';
import { StyledDropdownContainer, StyledPrintDiv } from './styled';
import { PrintChecksHeaderProps } from './types';

export const PrintChecksHeader = ({
  handlePrintCheckButtonClick
}: PrintChecksHeaderProps): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const selectedPrintChecks = useAppSelector(getSelectedVendors);
  const isAuthorizedToCancelPayment = useAppSelector(
    getUserRoleIsApOfficeManager
  );
  const intl = useIntl();
  const { data: glCalendarData } = useFetchOpenGlCalendars();

  useEffect(() => {
    dispatch(setPrintBtnDisabledOnRowFiltering(false));
  }, [dispatch]);

  return (
    <StyledHeaderContainer data-testid="print-checks-header">
      <StyledDropdownContainer>
        {glCalendarData ? (
          <PaymentDatePicker glCalendarData={glCalendarData} />
        ) : null}
        <PrintChecksCIBDropdown />
      </StyledDropdownContainer>
      <StyledPrintDiv>
        {selectedPrintChecks?.length > 0 && (
          <StyledSelectedChecksSpan>{`${selectedPrintChecks?.length} ${
            selectedPrintChecks?.length > 1
              ? intl.formatMessage(labels.checksSelected)
              : intl.formatMessage(labels.checkSelected)
          }`}</StyledSelectedChecksSpan>
        )}
        {isAuthorizedToCancelPayment && <CancelPaymentHeaderButton />}
        <PrintChecksHeaderButton
          handlePrintCheckButtonClick={handlePrintCheckButtonClick}
        />
      </StyledPrintDiv>
    </StyledHeaderContainer>
  );
};
